import React, {useContext} from "react";
import { useTranslation } from "react-i18next";
import { CButton } from "@app/components/Common";
import { Text, View } from "@/styles/reactnative";
import { COLORS } from "@app/constants";
import { useTradeModalStore } from "@app/hooks/trade/modalStore";
import BigNumber from "bignumber.js";
import TIcon from '../../../../../pages/QBIT/Qp2pPage/assets/TIcon.svg?react'
import styled from "styled-components";
import {Popover } from 'antd';
import {MobileCalVW, useIsMobile, useIsTablet} from "@utils/CalVW.tsx";
import { IconDotsVertical } from "@tabler/icons-react";
import {ThemeContext} from "@/theme/ThemeProvider.tsx";
import { formatDecimal4Truncate } from '@utils/formatDecimal.tsx';

const AssetDerivativesTableList = ({ data }) => {
  const { t } = useTranslation();
  const { data: modalStore, mutate: muatateModalStore } = useTradeModalStore();
  const isTablet = useIsTablet();
  const isMobile = useIsMobile();
  const { isDarkMode } = useContext(ThemeContext);

  return (
    <View
      style={{
        width: "100%",
        paddingBlock: 10
      }}
    >
      {isMobile ?
        data?.map((item: any, index: number) => (
          <div style={{width: '100%', paddingInline: '15px'}}>
            <div >
              <Text
                style={{
                  fontSize: 15,
                  justifyContent: "left",
                  marginBottom: 10
                }}
              >
                {t('coin')} :
                <IconSVG as={TIcon} style={{marginRight: isMobile ? 5 : 10}}/>
                {item?.coin}
              </Text>
              <Text
                style={{
                  fontSize: 15,
                  justifyContent: "left",
                  marginBottom: 10
                }}
              >
                {t('balance')} :
                {formatDecimal4Truncate(item?.balance || 0)}
              </Text>
              <Text
                style={{
                  fontSize: 15,
                  justifyContent: "left",
                  marginBottom: 10
                }}
              >
                {t('availableBalance')} :
                {formatDecimal4Truncate(item?.availableBalance || 0)}
              </Text>
              <Text
                style={{
                  fontSize: 15,
                  justifyContent: "left",
                  marginBottom: 10
                }}
              >
                {t('inOrderWithdrawals')} :
                {formatDecimal4Truncate(item?.inOrderWithdrawals || 0)}
              </Text>
              <Text
                style={{
                  fontSize: 15,
                  justifyContent: "left",
                  marginBottom: 10
                }}
              >
                {t('eventBalance')} :
                {item?.eventBalance}
              </Text>
            </div>
          </div>
        ))
        :
        data?.map((item: any, index: number) => (
        <View
          key={index.toString()}
          style={{
            width: "100%",
            height: 50,
            flexDirection: "row",
            paddingLeft: 15
          }}
        >
          <Text
            style={{
              fontSize: isMobile ? MobileCalVW(9) : 15,
              width: `20%`,
              justifyContent: "center",
            }}
          >
            <IconSVG as={TIcon} style={{marginRight: isMobile ? 5 : 10}}/>
            {item?.coin}
          </Text>
          <Text
            style={{
              fontSize: isMobile ? MobileCalVW(9) : 15,
              width: `20%`,
              justifyContent: "center",
            }}
          >
            {BigNumber(item?.balance || 0).toFormat(4)}
          </Text>
          <Text
            style={{
              fontSize: isMobile ? MobileCalVW(9) : 15,
              width: `20%`,
              justifyContent: "center",
            }}
          >
            {BigNumber(item?.availableBalance || 0).toFormat(4)}
          </Text>
          <Text
            style={{
              fontSize: isMobile ? MobileCalVW(9) : 15,
              width: `20%`,
              justifyContent: "center",
            }}
          >
            {item?.lockBalance}
          </Text>
          <Text
            style={{
              fontSize: isMobile ? MobileCalVW(9) : 15,
              width: `20%`,
              justifyContent: "center",
            }}
          >
            {item?.eventBalance}
          </Text>
          {/* {isTablet ?
            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
              <Popover
                placement="bottom"
                overlayInnerStyle={{backgroundColor: isDarkMode ? '#333333' : '#EFD9D0'}}
                arrow={false}
                content={
                  <View style={{ width: "100%", flexDirection: "column", gap: 20, backgroundColor: isDarkMode ? '#333333' : '#EFD9D0' }}>
                    <CButton
                      title={t("deposit")}
                      style={{ color: COLORS.secondary }}
                      onClick={() => {
                        muatateModalStore({
                          ...modalStore,
                          depositModal: true,
                        });
                      }}
                    />
                    <CButton
                      title={t("withdrawList")}
                      style={{ color: COLORS.secondary }}
                      onClick={() => {
                        muatateModalStore({
                          ...modalStore,
                          withdrawModal: true,
                        });
                      }}
                    />
                    <CButton
                      title={t("transfer")}
                      style={{ color: COLORS.secondary }}
                      onClick={() => {
                        muatateModalStore({
                          ...modalStore,
                          transferModal: true,
                        });
                      }}
                    />
                  </View>
                }
              >
                <IconDotsVertical style={{ color: COLORS.secondary, cursor: "pointer" }} />
              </Popover>
            </div>
            :
            <View style={{ width: "16.6%", flexDirection: "row", justifyContent: "left" }}>
              <CButton
                title={t("deposit")}
                style={{ color: COLORS.secondary }}
                onClick={() => {
                  muatateModalStore({
                    ...modalStore,
                    depositModal: true,
                  });
                }}
              />
              <CButton
                title={t("withdrawList")}
                style={{ color: COLORS.secondary }}
                onClick={() => {
                  muatateModalStore({
                    ...modalStore,
                    withdrawModal: true,
                  });
                }}
              />
              <CButton
                title={t("transfer")}
                style={{ color: COLORS.secondary }}
                onClick={() => {
                  muatateModalStore({
                    ...modalStore,
                    transferModal: true,
                  });
                }}
              />
            </View>
          } */}
        </View>
      ))}
    </View>
  );
};

export default AssetDerivativesTableList;

const IconSVG = styled.svg`
    width: 30px;
`